import React from "react";
import Slider from "react-slick";

export const Clients = () => {
  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1500,
    autoplaySpeed: 1500,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
       {
        breakpoint: 460,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <div className="wrapper_clients_logos">
      <Slider {...settings}>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente01.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente02.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente03.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente04.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>

        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente05.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente06.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente07.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente08.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente09.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente010.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente011.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente012.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente013.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente014.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente015.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente016.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente017.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente018.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente019.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente020.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente021.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente022.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente023.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
        <div className="item_clients">
          <img
            src={require("../../assets/imgs/clients/cliente024.png")}
            alt="Clientes en Jc Innovation"
          />
        </div>
      </Slider>
    </div>
  );
};
